import React from "react";
import {Skeleton} from "./utils/Skeleton";

interface ProductActualizeProps {
    needUpdate: boolean;
    lastActualize: string;
    inStock: boolean;
}

const ProductActualize: React.FC<ProductActualizeProps> = ({ needUpdate, lastActualize, inStock }) => {
    return (
        <div className="mb-2 text-[#9E9E9E] text-[12px] font-medium flex items-center">
            { needUpdate
                ? <Skeleton className="h-[18px] w-[195px]" />
                : <>
                    <span className={`${inStock ? 'bg-[#78BA66]' : 'bg-[#E73140]'} w-[10px] h-[10px] rounded-full mr-4`}></span>
                    <span>{lastActualize}</span>
                </>
            }
        </div>
    );
};

export default ProductActualize;